import React from 'react';
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';
import history from '../../history';

export const Registration = () => (
  <div>
  <Helmet>
    <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Registration</title>
  </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item"><a>Information</a></li>
        <li class="breadcrumb-item active" aria-current="page">Registration</li>
      </ol>
    </nav>
    <h2>Registration & Invitation</h2>

    <p style={{ textAlign:'justify'}}>
      Dear Tan Sri/Dato’ Sri/Professor/Associate Professor/Dr/Sir/Madam,<br/><br/>
      Universiti Teknologi MARA, Malaysia & Institut Teknologi Sepuluh Nopember, Indonesia cordially invite you to join SCDS2021 -The 6th 
      International Conference on Soft Computing in Data Science virtual conference with the theme "Science in Analytics: Harnessing Data and Simplifying Solutions" 
      on 2 and 3 November 2021 on Zoom platform.<br/><br/>

      Date: 2 November 2021 (Tuesday)<br/>
      Time: 8.45 am – 5.00 pm MYT<br/>
      Platform: ZOOM Webinar<br/><br/>

      Click here to join: <a href="http://its.id/SCDS2021" target="_blank" rel="noreferrer">http://its.id/SCDS2021</a><br/><br/>

      Date: 3 November 2021 (Wednesday)<br/>
      Time: 8.00 am – 6.00 pm MYT<br/>
      Platform: ZOOM Webinar<br/><br/>

      Click here to join: <a href="http://its.id/SCDS2021_day2" target="_blank" rel="noreferrer">http://its.id/SCDS2021_day2</a><br/><br/>

      Link to SCDS2021 program schedule: <a style={{cursor:'pointer'}} onClick={() => history.push('/scds2021/programBook')}><b>Click here.</b></a><br/><br/>
    </p>

  </div>
)